import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
type CountUpProps = {
  to: number;
};
export function CountUp({
  to
}: CountUpProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.6
  });
  const reduce = useReducedMotion();
  const [value, setValue] = useState(reduce ? to : 0);
  useEffect(() => {
    if (reduce) {
      setValue(to);
      return;
    }
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.2,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => setValue(Math.round(v))
    });
    return () => controls.stop();
  }, [inView, reduce, to]);
  return <span ref={ref} className="tabular-nums" data-id="element-2" data-mp="rgb2tmmbcpho">
      <span aria-hidden="true" data-id="element-3" data-mp="rehvs67sg395">{value}</span>
      <span className="sr-only" data-id="element-4" data-mp="3qgpl3y30yww">{to}</span>
    </span>;
}